import { MyPortfolio } from "@/components/portfolio/MyPortfolio";

export default function MyPortfolioPage() {
  return <MyPortfolio />;
}